import React, { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { tokensState, referrerState } from '../features/auth';
import { Route, RouteProps, Redirect, useLocation } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

export function PrivateRoute(props: RouteProps) {
	const tokens = useRecoilValue(tokensState);
	const { hash, pathname, search, state } = useLocation();

	const setReferrer = useSetRecoilState(referrerState);

	useEffect(() => {
		if (!tokens)
			setReferrer({
				hash,
				pathname,
				search,
				state,
			});
	}, [tokens, hash, pathname, search, state, setReferrer]);

	return tokens ? (
		<ErrorBoundary>
			<Route {...props} />
		</ErrorBoundary>
	) : (
		<Redirect to="/sign_in" />
	);
}
